import { FC } from 'react'
import errorRed from '@/assets/img/error-red.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={errorRed}
      alt='Error'
      width={width}
      height={height}
    />
  )
}

export default Icon
